
import { Component, Vue, Prop} from 'vue-property-decorator';

import Form22ProcessHeader from "@/components/process/Form22/components/Form22ProcessHeader.vue";
import { form22StatusInfoType } from '@/types/Information/Form22';

@Component({
    components:{
        Form22ProcessHeader
    }
})
export default class ErrorSubmitForm22 extends Vue {
    
    @Prop({required: true, default:" "})
    errMsg!: string;

    stepsCompleted = {} as form22StatusInfoType;  
    mountedData = false;     

    mounted() {
        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false,
            thirdError:true
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }

    public contactUs(){
        const ContactButton = document.getElementsByName("contact-us");
        if(ContactButton[0]) ContactButton[0].click()
    }
}
